const ready = require('./utilities').ready;

ready(init);

function init() {
  const switchMonthly = document.querySelector('.js-subscription-switch-monthly');

  if (switchMonthly) {
    switchPlanEventHandler();
  }

  // Capture phase so we record the click even if a nested span was the target
  // or LemonSqueezy handlers interfere with bubbling.
  document.addEventListener('click', handleCtaClick, true);

  const buttons = document.querySelectorAll('.js-subscription-button');
  if (!buttons.length) {
    return;
  }

  buttons.forEach(button => {
    button.addEventListener('click', open);
  });
  lemonSqueezyEventHandler();
}

function handleCtaClick(event) {
  if (!event.target.closest('.js-subscription-button')) {
    return;
  }
  trackCtaClick();
}

// Proxy/leading metric for the /pro landing-page A/B test: records that the
// user clicked a checkout CTA. Fire-and-forget; ignores any failure.
function trackCtaClick() {
  const tokenEl = document.querySelector('meta[name="csrf-token"]');
  fetch('/pro/track-cta', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': tokenEl ? tokenEl.content : '',
      'X-Requested-With': 'XMLHttpRequest'
    },
    keepalive: true
  }).catch(() => {});
}

function open(event) {
  const button = event.currentTarget;
  let url = 'https://stockcircle.lemonsqueezy.com/checkout/buy';
  let plan = button.dataset.plan;

  if (!plan) {
    const planSwitch = document.querySelector('.js-subscription-switch-monthly');
    plan = planSwitch && planSwitch.checked ? 'monthly' : 'annual';
  }

  if (plan === 'monthly') {
    // url += '/38f61588-8ac4-4c8e-9bff-8bf337a3fb40?enabled=286470'; // dev
    url += '/1b387bd1-38ac-4bd1-88f2-d728088aa81d?enabled=289471'; // monthly
  } else {
    // url += '/926d326c-9bf0-4bf2-befe-30a040c78d41?enabled=286475'; // dev
    url += '/b0978de4-8029-4a13-993b-87e0e547bd85?enabled=289472'; // annual
  }

  const email = button.dataset.email;
  const name = button.dataset.name;

  url += `&embed=1&media=0&logo=0&checkout[email]=${email}&checkout[name]=${name}`;
  LemonSqueezy.Url.Open(url);
}

function lemonSqueezyEventHandler(count = 0) {
  if (count > 6) {
    return;
  }

  if (typeof LemonSqueezy === 'undefined') {
    window.setTimeout(() => lemonSqueezyEventHandler(count + 1), 200);
    return;
  }

  LemonSqueezy.Setup({
    eventHandler: (event) => {
      if (event.event && event.event === 'Checkout.Success') {
        createSubscription(event.data.order.data.id);
      }
    }
  });
}

function createSubscription(orderId) {
  fetch('/pro', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      order_id: orderId
    })
  }).then(response => {
    return response.json();
  }).then(data => {
    if (data.success) {
      const planSwitch = document.querySelector('.js-subscription-switch-monthly');
      const purchaseValue = planSwitch && planSwitch.checked ? 16.49 : 99;
      fbq('track', 'Purchase', { currency: "USD", value: purchaseValue });
      window.setTimeout(() => window.location.reload(), 2000);
    } else if (data.error) {
      alert(data.error);
    }
  });
}

function switchPlanEventHandler() {
  const switchMonthly = document.querySelector('.js-subscription-switch-monthly');
  const switchAnnual = document.querySelector('.js-subscription-switch-annual');

  switchMonthly.addEventListener('change', () => {
    document.querySelector('.js-subscription-monthly-plan').classList.add('utilities__hidden');
    document.querySelector('.js-subscription-annual-plan').classList.remove('utilities__hidden');
  });

  switchAnnual.addEventListener('change', () => {
    document.querySelector('.js-subscription-annual-plan').classList.add('utilities__hidden');
    document.querySelector('.js-subscription-monthly-plan').classList.remove('utilities__hidden');
  });
}
